
export default {
 //上传文件图片
  uploadFileImg: "crmservice/api/mistake/uploadFileImg",
  //新增漏洞纰漏
  addMistakeInfo: "crmservice/api/mistake/addMistakeInfo",
  //删除图片
  delFileImg: "crmservice/api/mistake/deleteImageObject",
  //查询漏洞纰漏
  checkMistakeInfo: "crmservice/api/mistake/selectMistakeInfo",
  //根据经销商id获取经销商基本信息
  getMsgByDealersId: "crmservice/api/mistake/getMsgByDealersId",
  //查询漏洞更新日志
  getBugFixList: "crmservice/api/mistake/selectBugFixList",
  //查询漏洞纰漏数据详情
  getBugFeedBackInfo: "crmservice/api/mistake/getMistakeInfo",
  //查询产品维护周期数据列表
  getProductMaintList: "cloudservice/api/product/maint/h5/selectProductMaintPage",
  
}



// WEBPACK FOOTER //
// ./src/utils/api.js